<template>
  <div class="couponTabBox" >

        <!-- 内容 -->
        <div  v-if="coupons.length > 0">
        <div class="coupon_box flex_center" v-for="(coupon,index) in coupons" :key="index" >
          <div class="coupon_left">
            <img src="/static/img/coupon_bg.png" alt />
            <div style="position:absolute;top:13%;left:0;width:100%;">
              <p class="coupon_price">￥{{coupon.price}}</p>
              <p class="coupon_type">代金券</p>
            </div>
          </div>
          <div class="flex_center" style="width: 65%;">
            <div class="coupon_middle">
              <p class="coupon_condition">{{coupon.coupon_name}}</p>
              <p class="coupon_usetime">满{{coupon.enough}}使用</p>
              <p class="coupon_usetime" v-if="coupon.use_starttime!=0">{{coupon.use_starttime}}-{{coupon.use_endtime}}</p>
              <p class="coupon_usetime" v-else>随时可用</p>
            </div>
            <div class="coupon_right" v-if="status == 0">
              <button class="gotouse_btn" @click="go_use">立即使用</button>
            </div>
            <div class="coupon_right" v-if="status == 1">
              <span class="iconfont icon-yishiyong"></span>
            </div>
            <div class="coupon_right" v-if="status == 2">
              <span class="iconfont icon-yiguoqi"></span>
            </div>
          </div>
        </div>
        </div>

        <div class="order__emptyBox" v-else>
          <img src="/static/img/no_coupon.png" alt />
          <p>暂无可用优惠券</p>
        </div>
  </div>
</template>

<script>
export default {
  name: "couponTabBox",
  components: {},
  props: ['status'],
  data() {
    return {
      coupons:[]
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.get_coupons();
    },
    get_coupons(){
      this.axios({
        url: this.api.member.get_coupons, 
        data: {status:this.status}
      }).then(res => {
        if (res.error === 0) {
          this.coupons = res.member_coupons;
        }
      });
    },
    go_use(){
      this.$router.push('/book');
    }
  }
};
</script>
<style scoped>
  .coupon_box {
    margin: .5rem;
    background-color: white;
    clear: both;
    overflow: hidden;
  }
  .coupon_left {
    position: relative;
    color: #ffffff;
    text-align: center;
    width: 35%;
    clear: both;
  }
  .coupon_left img {
    width: 100%;
    height: 3.3rem;
  }
  .coupon_price {
    font-size: 1.2rem;
    font-weight: bold;
  }
  .coupon_type {
    font-size: 0.6rem;
  }
  .coupon_middle {
    width: 62%;
    padding-left: 5%;
  }
  .coupon_right {
    width: 38%;
    font-size: 0.6rem;
    color: #45b9bc;
    padding-right: .5rem;
    text-align: right;
  }
  .coupon_condition {
    font-size: 0.6rem;
    color: #6a6969;
    padding-bottom: 0.2rem;
  }
  .coupon_usetime {
    font-size: 0.5rem;
    color: #a3a3a3;
  }
  .gotouse_btn {
    border: 1px solid #45b9bc;
    border-radius: 5px;
    padding: 0.2rem 0.3rem;
  }
.icon-yishiyong,
.icon-yiguoqi {
  font-size: 2.2rem;
  color: #b6b6b5;
}
</style>



// WEBPACK FOOTER //
// src/components/couponTabBox.vue